<template>
  <div class="yuncang" :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }">
    <van-nav-bar title="说明" left-arrow @click-left="onClickLeft" />
    <div class="main">
      <div>
        <h2>一、用户下单及订单信息推送</h2>
        <p>
          1、平台收到海外仓(香港仓、米兰仓）直邮商品订单后，以意大利工作日时间为基准，
          72
          小时内确认订单库存。若无库存，将自动取消订单。若有库存，在确认有库存后的
          4 个工作日内（以意大利时间为基准）完成发货。
        </p>
        <p>
          2、平台收到国内仓（深圳、杭州）订单后，以国内工作时间为基准 72
          小时内确认订单信息进行发货。
        </p>
      </div>
      <div>
        <h2>二、本商品无质量问题不支持退换货</h2>
        <p>
          1、用户自收到商品7个自然日内，如包裹符合以下情况，用户可向平台申请退货及退款，运费由平台承担：
        </p>
        <p style="text-indent: 2em">
          1.1、商品如果在运输过程中造成破损，用户需提供外包装、快递面单、商品等照片作为书面证据，若无法提供书面证据，平台拒绝受理。
        </p>
        <p style="text-indent: 2em">
          1.2、遇到商品丢件、错发、漏发等情况，在经快递人员证明及核查情况属实后，可予以受理。
        </p>
        <p>2、用户务必保证商品完好、全新，且尚未使用过。</p>
        <p>
          3、用户务必确保原包装配件、订单纸、吊牌、包装、身份卡等所有相关物件完好齐全，退货商品防伪溯源标签完好无损。
        </p>
        <p>
          4、商品在发出后因不可抗力等无法避免的因素出现轻微破损，但不影响正常使用，则不构成退货条件。
        </p>
        <p>
          5、平台受理您所提交的相关退换货申请后一周内，如未收到关于退货申请的相应商品包裹，
          将自动取消退货退款流程（退货地址另行约定）。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isiOSX: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.yuncang {
  background: #f5f6f7;
  height: 100%;
  box-sizing: border-box;
  .main {
    background: #fff;
    padding: 10px 12px;
    height: calc(100% - 44px);
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    h2 {
      margin: 10px 0;
      font-size: 16px;
      color: #666666;
      line-height: 22px;
    }
    p {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin: 10px 0;
      font-size: 15px;
      line-height: 24px;
      color: #999999;
    }
  }
}
</style>
<style lang="less">
.yuncang {
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: solid 1px #f5f6f7;
  }
}
</style>